import React, { PureComponent } from 'react';
export default class FormVirtualGroup extends PureComponent {
    render() {
        const { children } = this.props;
        return React.createElement("div", null, children);
    }
}
FormVirtualGroup.displayName = 'FormVirtualGroup';
